import { render } from "./EmployeeDetailsPageProfileContracts.vue?vue&type=template&id=c6d630c8"
import script from "./EmployeeDetailsPageProfileContracts.vue?vue&type=script&lang=ts"
export * from "./EmployeeDetailsPageProfileContracts.vue?vue&type=script&lang=ts"
script.render = render

export default script